import type { CommandMiddleware } from "../contracts";
import type { PendingCommandRegistry } from "./pendingRegistry";
import { commandSignature } from "./signatures";

// Wraps every dispatch with pending-state tracking. Marks the signature as
// pending before `next()` runs, clears it on resolve OR reject. Lives in the
// bus middleware chain alongside log / confirm-guard / error→toast.
//
// Placement note (matters when other middleware can short-circuit): mount this
// AFTER confirm-guard so a rejected confirm doesn't flash the spinner; mount
// it BEFORE error→toast so the spinner clears before the toast displays.
export function createPendingTrackMiddleware(registry: PendingCommandRegistry): CommandMiddleware {
    return async (command, next) => {
        const signature = commandSignature(command);
        // Coalesce double-clicks at the bus level — if the same signature is
        // already in flight, drop the second dispatch. Returns undefined so
        // the caller's `await dispatch(...)` resolves harmlessly.
        if (registry.has(signature)) return undefined;
        registry.add(signature);
        try {
            return await next();
        } finally {
            registry.remove(signature);
        }
    };
}
